// This store is for the courses for the login users.
/*eslint-disable */
import toast from '../services/toast'
import axios from 'axios';
import root from '../_helpers/roots';
import router from '../route';
// Get Latest courses
let dataUrl = root.latestCourses.link;

// Add course to my course
let setEnrollUrl = root.enrollCourses.link;

// Get Single Course
let enrolledSingleCourseUrl = root.enrolledSingleCourse.link

// Get my course list
let getEnrolledCourseListUrl = root.enrolledCoursesList.link

// Remove from my course
let removeFromMycourseUrl = root.removeEnrolledCourse.link

// Course Category
let courseCatgoryUrl = root.getCourseCatgoryUrl.link;

// Course By Category
let courseByCategroyUrl = root.courseByCategory.link

// Course Section File Read
let courseSectionFileReadURL = root.courseSectionFileReadUrl.link

export default {
  state: {
    latestCourseState: {},
    enrollNewCourse: false,
    userEnrolledCourses: {},
    singleCourse: {},
    removeMyCourse: false,
    categoryList: {},
    couseByCategoryList: {},
    favCourseByNumber: {},
    filterResultState: {}
  },
  mutations: {
    setcourses(state, courses) {
      state.latestCourseState = courses.data.data;
    },
    enrollCourses(state, value) {
      state.enrollNewCourse = value;
    },
    enrolledCourses(state, value) {
      state.userEnrolledCourses = value;
    },
    singleEnrollCourse(state, value) {
      state.singleCourse = value
    },
    removeFromMyCourse(state, value) {
      state.removeMyCourse = value;
    },
    categoryListMut(state, value) {
      state.categoryList = value;
    },
    couseByCategoryMut(state, value) {
      state.couseByCategoryList = value;
    },
    setFavCourseByNumber(state, value) {
      state.favCourseByNumber = value;
    },
    filterCourseMut(state, value) {
      state.filterResultState = value;
    }
  },
  actions: {

    getcourselist(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(dataUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('setcourses', response);

            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {

            reject(error);
          });
      })
    },

    getcourselistByCat(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(dataUrl + '?course=' + payload.id).then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('setcourses', response);

            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {

            reject(error);
          });
      })
    },

    setEnrollNewCourse(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(setEnrollUrl, payload).then((response) => {
            // context.commit('enrollCourses', response.data.data);
            if (response.status != '401' && response.status != '403') {

            } else {
              router.push('/login')
            }

            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },

    getEnrolledCoursesActn(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(getEnrolledCourseListUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('enrolledCourses', response.data.data);

            } else {
              router.push('/login')
            }

            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    EnrolledCourseByNumber(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(getEnrolledCourseListUrl + '?page_size=5').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('setFavCourseByNumber', response.data.data);

            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    getSingleCourseDetail(context, payload) {
      return new Promise((resolve, reject) => {
        let singleCourseUrl = enrolledSingleCourseUrl + payload.courseid + '/';
        axios.get(singleCourseUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              if (response.status != '400') {
                context.commit('singleEnrollCourse', response.data.data);
              } else {
                toast.error(res.data.msg);
              }
              resolve(response);
            } else {
              router.push('/login')
            }
          })
          .catch(function(error) {
            //    console.log(error);
            reject(error);
          });
      })
    },
    getSingleCourseFileRead(context, payload) {
      return new Promise((resolve, reject) => {
        let singleCourseFileReadUrl = courseSectionFileReadURL + payload.courseFileid + '/';
        axios.get(singleCourseFileReadUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              if (response.status != '400') {
                // context.commit('singleEnrollCourse', response.data.data);
              } else {
                toast.error(res.data.msg);
              }
              resolve(response);
            } else {
              router.push('/login')
            }
          })
          .catch(function(error) {
            //    console.log(error);
            reject(error);
          });
      })
    },
    removeMyCourse(context, payload) {
      return new Promise((resolve, reject) => {
        let removeUrl = removeFromMycourseUrl + payload.courseid + '/';
        axios.delete(removeUrl).then((response) => {
            console.log(response);
            if (response.status != 401 && response.status != 403) {

              if (response.status == 200) {

                context.commit('removeFromMyCourse', response.data.data);
                resolve(response);
              }

            } else {
              router.push('/login')
            }

          })
          .catch(function(error) {
            // console.log(error);
            reject(error);
          });
      });
    },

    getCategoryListActn(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(courseCatgoryUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('categoryListMut', response.data.data)

            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {
            // console.log(error);
            reject(error);
          });
      });
    },

    CourseByCategoryAction(context, payload) {
      return new Promise((resolve, reject) => {
        let cousebycategoryUrl = courseByCategroyUrl + payload.id + '/';
        axios.get(cousebycategoryUrl).then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('couseByCategoryMut', response.data.data)

            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },

    filterField(context, payload) {
      return new Promise((resolve, reject) => {
        let coursebyFilterName = dataUrl + '?name=' + payload.name;
        //    console.log(coursebyFilterName);
        axios.get(coursebyFilterName).then((response) => {

            if (response.status == '200') {
              context.commit('filterCourseMut', response.data.data);
            } else {
              router.push('/login')
            }

            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    }
  },
  getters: {
    lastestcourses: state => state.latestCourseState,
    erolledCourses: state => state.userEnrolledCourses,
    getSingleCourse: state => state.singleCourse,
    getCategoryList: state => state.categoryList,
    getCourseByCategory: state => state.couseByCategoryList,
    getEnrolledCourseByNumber: state => state.favCourseByNumber,
    filterResultDetials: state => state.filterResultState
  }
}

//export default courses;